<template lang="html">
  <NumericResultBase :value="result ? result.detailedScore : null">
    <slot />

    <template #value="{value: {roundedScore}}">
      {{ roundedScore }}
    </template>
  </NumericResultBase>
</template>

<script>
import NumericResultBase from './NumericResultBase'

export default {
  components: {
    NumericResultBase
  },
  props: {
    result: Object
  }
}
</script>

<style lang="scss" module>
</style>
